var __templateData = Handlebars.template({"1":function(depth0,helpers,partials,data) {
  var helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"effect-input-container\">\n  <span>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "es:outcome.diagnostic.effect_per", {"name":"i18n","hash":{},"data":data})))
    + "</span>\n  <div class=\"inline\">\n    "
    + escapeExpression(((helpers.absDenominatorSelectableAttr || (depth0 && depth0.absDenominatorSelectableAttr) || helperMissing).call(depth0, (depth0 != null ? depth0.absDenominator : depth0), {"name":"absDenominatorSelectableAttr","hash":{},"data":data})))
    + "\n  </div>\n  <span>"
    + escapeExpression(((helpers.i18n || (depth0 && depth0.i18n) || helperMissing).call(depth0, "es:outcome.diagnostic.patients_tested", {"name":"i18n","hash":{},"data":data})))
    + "</span>\n</div>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, helperMissing=helpers.helperMissing, buffer = "";
  stack1 = ((helpers.compoundEdit || (depth0 && depth0.compoundEdit) || helperMissing).call(depth0, "absDenominator", "diagnostic.effect_per", {"name":"compoundEdit","hash":{},"fn":this.program(1, data),"inverse":this.noop,"data":data}));
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}